export const EMBRACE_SESSION_NUMBER_STORAGE_KEY = 'embrace_session_number';
